import { render, staticRenderFns } from "./personalProperti.vue?vue&type=template&id=17c0b7bf&"
import script from "./personalProperti.vue?vue&type=script&lang=ts&"
export * from "./personalProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports